module.exports = __webpack_public_path__ + "img/ysw.ce554e81.jpg";